import React from 'react';
import '../App.css';
import {ellipses} from '../Helpers';
import editButton from '../images/edit_button.png';
import editButtonHover from '../images/edit_button_hover.png';

export default class Message extends React.Component {

  constructor(props) {
    super(props);
    this.state = {expanded: false, editButton: editButton};
  }

  handleMouseOut(e) {
    this.setState({editButton: editButton});
  }

  handleMouseOver(e) {
    this.setState({editButton: editButtonHover});
  }

  render() {
    let image = '';
    if (this.props.itemImage && this.props.itemImage.indexOf('missing.png') === -1) {
      image = <img src={window.location.protocol + this.props.itemImage} alt=' ' />;
    }
    let expandedElements = <div className='itemExpandedInfo'>
       <div>&nbsp;&nbsp; Nome: {this.props.itemName}</div>
       <div>&nbsp;&nbsp; Descrição : {this.props.itemDescription}</div>
       <div>&nbsp;&nbsp; Serial : {this.props.itemSerial}</div>
       <div>&nbsp;&nbsp; Valor: {this.props.itemValue}</div>
       <div>&nbsp;&nbsp; AssetTag: {this.props.itemAssetTag}</div>
       <div>&nbsp;&nbsp; Labels: {this.props.itemLabels}</div>
       <div>&nbsp;&nbsp; Private: {this.props.itemPrivate ? 'true' : 'false'}</div>
       <div>&nbsp;&nbsp; {image} </div>
    </div>;
    return (
      <div className='itemDiv'>
        <div className='itemExpander'>
          { this.state.expanded ?
            <span className='fakeLink' onClick={() => this.setState({expanded: false})}> &nbsp;V </span>
            : <span className='fakeLink' onClick={() => this.setState({expanded: true})}> &nbsp;> </span> }
        </div>
        <div className='itemName'>
          {ellipses(this.props.itemName, 14) || <span>&nbsp;</span>}
        </div>
        <div className='itemDesc'>
          {ellipses(this.props.itemDescription, 34) || <span>&nbsp;</span>}
        </div>
        <div className='itemSerial'>
          {ellipses(this.props.itemSerial, 15) || <span>&nbsp;</span>}
        </div>
        <div className='itemEdit'>
           <img className='editButton' style={{width: '20px', marginRight: '6px'}}
                src={this.state.editButton} alt='Edit'
                onMouseOut={(e) => this.handleMouseOut(e)}
                onMouseOver={(e) => this.handleMouseOver(e)}
                onClick={(e) => this.props.setEditingItem(this.props.itemId)} />
        </div>
        {this.state.expanded ? expandedElements : <span>&nbsp;</span>}
      </div>
    );
  }
}
